import { Overrides } from "@material-ui/core/styles/overrides";

import Palette from "./palette";

export const datePickerOverrides = (): Overrides => ({
  MuiPaper: {
    root: {
      "& .MuiPickersCalendarHeader-iconButton": {
        border: "1px solid #CCCCCC",
        borderRadius: "8px",
        color: Palette.grey[900],
        "&:hover": {
          border: "1px solid #CCCCCC",
          backgroundColor: "#EEEEEE",
          color: Palette.grey[900]
        }
      },
      "& .MuiPickersBasePicker-container": {
        padding: "24px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
        borderRadius: "8px"
      },
      "& .MuiPickersCalendarHeader-switchHeader": {
        marginBottom: "16px",
        "& .MuiTypography-body1": {
          fontWeight: 700,
          fontSize: "20px",
          lineHeight: "26px"
        }
      },
      "& .MuiPickersBasePicker-pickerView": {
        borderBottom: `1px solid ${Palette.divider}`,
        paddingBottom: "16px",
        minHeight: "370px",
        justifyContent: "start"
      },
      "& .MuiPickersDay-day": {
        color: Palette.grey[900],
        border: 0,
        borderRadius: "8px",
        margin: "5px",
        "&:hover": {
          color: Palette.info.main,
          borderColor: Palette.info.main,
          border: "1px solid"
        }
      },
      "& .MuiPickersDay-current": {
        color: Palette.info.main,
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
        border: `1px solid ${Palette.info.main}`
      },
      "& .MuiPickersDay-day.MuiPickersDay-daySelected": {
        color: "#FFF",
        backgroundColor: Palette.info.main,
        "&:hover": {
          backgroundColor: Palette.info.main,
          color: "#FFF"
        }
      },
      "& .MuiPickersCalendarHeader-dayLabel": {
        margin: "0 5px",
        fontSize: "16px",
        color: "#999999"
      }
    }
  }
});
